/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddressSearchResultDto } from '../models/work-address-search-result-dto';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceGenericService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceGenericV2ControllerSearchAddress()` */
  static readonly SelfserviceGenericV2ControllerSearchAddressPath = '/v2/selfservice/generic/address-search';

  /**
   * Search for addresses using Google Places API.
   *
   * Search for addresses to help users find and select proper project addresses
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceGenericV2ControllerSearchAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceGenericV2ControllerSearchAddress$Response(
    params: {

    /**
     * Search query for address (e.g., "Hauptstrasse 1, Zürich")
     */
      query: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAddressSearchResultDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceGenericService.SelfserviceGenericV2ControllerSearchAddressPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAddressSearchResultDto>>;
      })
    );
  }

  /**
   * Search for addresses using Google Places API.
   *
   * Search for addresses to help users find and select proper project addresses
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceGenericV2ControllerSearchAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceGenericV2ControllerSearchAddress(
    params: {

    /**
     * Search query for address (e.g., "Hauptstrasse 1, Zürich")
     */
      query: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkAddressSearchResultDto>> {
    return this.selfserviceGenericV2ControllerSearchAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAddressSearchResultDto>>): Array<WorkAddressSearchResultDto> => r.body)
    );
  }

}
